/*Import modules to build Angular App*/
import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

/*Import modules to deal with Kendo controls*/
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { MenuModule } from '@progress/kendo-angular-menu';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';

/*Import service reference*/
import { AdalService } from 'adal-angular4';
import { LoginService } from './Service/login.service';
import { CommonService } from './Service/Common.service';
import { RestApiService } from './Service/rest-api.service';
import { EncryptDecryptService } from './Service/encrypt-decrypt.service';
import { GlobalErrorHandler } from './Service/Global/GlobalErrorHandler.service';
import { GlobalHttpInterceptor } from './Service/Global/GlobalHttpInterceptor.service';
import { ProjectInfoService } from './Service/project-info/project-info.service';

/*Import custom outside library reference*/
import { AppComponent } from './app.component';
import { AuthGuard } from './Service/Global/auth.guard';
import { environment } from 'src/environments/environment';
import { EIPMessageBoxModule, EIPMessageBoxComponent } from 'eipmessage-box';
import { EIPToastAlertModule, EIPToastAlertComponent } from 'eiptoast-alert';
import { EIPAutoCompleteModule } from 'eipauto-complete';
import { EIPMultiSelectAutoCompleteModule } from 'eipmulti-select-auto-complete';
import { EipCalculatorModule } from 'eip-calculator';
import { EipNotesModule } from 'eip-notes';
import { EDMSCommonModule } from './edmscommon.module';
import { EIPGeneralCartModule } from 'eipgeneral-cart';
import { MaterialModule } from './material.module';
import { MatTabsModule } from '@angular/material/tabs';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgImageSliderModule } from 'ng-image-slider';

/*Import custom inside project library reference*/
import { ProjectElementsComponent } from './CommonComponents/project-elements/project-elements.component';
import { AuthLayoutComponent } from './Modules/layouts/auth-layout/auth-layout.component';
import { AppHomeLayoutComponent } from './Modules/layouts/app-layout/app-home-layout.component';
import { EdmsCommonHeaderComponent } from './CommonComponents/edms-common-header/edms-common-header.component';
import { HeaderComponent } from './CommonComponents/header/header.component';
import { FooterComponent } from './CommonComponents/footer/footer.component';
import { AuthCallbackComponent } from './CommonComponents/authcallback';
import { HelpdeskSupportDetailsComponent } from './CommonComponents/header/helpdesk-support-details/helpdesk-support-details.component';
import { HeaderCalculatorComponent } from './CommonComponents/header/header-calculator/header-calculator.component';
import { HeaderNotesComponent } from './CommonComponents/header/header-notes/header-notes.component';
import { DashboardLayoutComponent } from './Modules/layouts/dashboard-layout/dashboard-layout.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/*Import child component reference*/

/*Import directive reference*/
@NgModule({
  declarations: [
    AppComponent,
    ProjectElementsComponent,
    EdmsCommonHeaderComponent,
    HeaderComponent,
    FooterComponent,
    AuthCallbackComponent,
    AuthLayoutComponent,
    AppHomeLayoutComponent,
    HelpdeskSupportDetailsComponent,
    HeaderCalculatorComponent,
    HeaderNotesComponent,
    DashboardLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DropDownsModule,
    DateInputsModule,
    ButtonsModule,
    GridModule,
    ExcelModule,
    DialogsModule,
    MenuModule,
    InputsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    EIPAutoCompleteModule,
    EIPMultiSelectAutoCompleteModule,
    EipCalculatorModule,
    EipNotesModule,
    EIPMessageBoxModule,
    MaterialModule,
    EIPToastAlertModule,
    EDMSCommonModule,
    EIPGeneralCartModule,
    PopupModule,
    MatTabsModule,
    MatSnackBarModule,
    NgImageSliderModule,
    ScrollViewModule,
    FontAwesomeModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    DatePipe,
    AuthGuard,
    ProjectInfoService,
    CommonService,
    EncryptDecryptService,
    LoginService,
    AdalService,
    RestApiService,
    EIPMessageBoxComponent,
    JwtHelperService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: 'environment', useValue: environment }
  ],
  bootstrap: [AppComponent],
  entryComponents: [EIPMessageBoxComponent, EIPToastAlertComponent, HelpdeskSupportDetailsComponent, HeaderCalculatorComponent, HeaderNotesComponent],
})
export class AppModule { }
